import React from "react";

export function StatusDot({ online, label }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium ${
        online ? "text-lime-600" : "text-zinc-500"
      }`}
      data-testid="status-dot"
    >
      <span
        className={`w-2 h-2 rounded-full ${
          online
            ? "bg-lime-500 shadow-[0_0_8px_rgba(132,204,22,0.6)]"
            : "bg-zinc-400"
        }`}
      />
      {label || (online ? "Online" : "Offline")}
    </span>
  );
}

export function Mono({ children, className = "" }) {
  return (
    <span className={`font-mono text-xs ${className}`}>{children}</span>
  );
}

export function CodePill({ children }) {
  return (
    <span className="inline-flex font-mono text-[11px] bg-zinc-100 border border-zinc-200 px-1.5 py-0.5 rounded text-zinc-800">
      {children}
    </span>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="text-center py-16 border border-dashed border-zinc-300 rounded-lg bg-white">
      <div className="font-heading text-base font-semibold mb-1">{title}</div>
      {hint && <p className="text-sm text-zinc-500 max-w-md mx-auto">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
